import * as analytics from "./util/segment";

export default class TrackClick {
    mount({ selector }) {
        const $tracks = $(selector);

        $tracks.each((i, el) => {
            $(el).click(() => {
                const { action, category, label } = $(el).data();

                analytics.track({
                    action: `click-${action}`,
                    category,
                    label,
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/track-click.js